(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rb_wixui.corvid[Collage]", [], factory);
	else if(typeof exports === 'object')
		exports["rb_wixui.corvid[Collage]"] = factory();
	else
		root["rb_wixui.corvid[Collage]"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 